<div class="d-flex table-select-container">
  <div>
    <button
      [ngClass]="
        selectedOverview === 'year'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('year')"
      type="button"
      mat-button
    >
      Overzicht immo aanvragen per dag
    </button>
  </div>
  <div>
    <button
      [ngClass]="
        selectedOverview === 'client'
          ? 'selected-button border-badge-selected'
          : 'non-selected-button border-badge'
      "
      (click)="changeSelectedView('client')"
      type="button"
      mat-button
    >
      Overzicht aanvragen per makelaar
    </button>
  </div>
</div>

<immo-job-year-overview
  *ngIf="selectedOverview === 'year'"
  (countChange)="updatePrintCount($event)"
>
</immo-job-year-overview>
<immo-job-client-overview
  *ngIf="selectedOverview === 'client'"
  (countChange)="updateTextCount($event)"
>
</immo-job-client-overview>